export default __webpack_public_path__ + "static/media/box-content-decor-gen.0c9a159a.svg";